var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6","offset-lg":"3"}},[_c('v-carousel',{attrs:{"height":"100%","cycle":"","show-arrows-on-hover":""}},_vm._l((_vm.items),function(item,i){return _c('v-carousel-item',{key:i,attrs:{"src":item.src}})}),1)],1),_c('v-col',[_c('h4',[_vm._v("Das Bad im Erdgeschoss.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }